import { render, staticRenderFns } from "./DemoRequest.vue?vue&type=template&id=6f7eef39&scoped=true"
import script from "./DemoRequest.vue?vue&type=script&lang=js"
export * from "./DemoRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7eef39",
  null
  
)

export default component.exports